var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',_vm._b({ref:"elInputRef",attrs:{"value":_vm.formattedValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }